import {
  createRouter,
  createWebHistory
} from 'vue-router'
import {
  BasicLayout
} from '@/layouts'

const routes = [{
    path: '/',
    component: BasicLayout,
    redirect: '/my',
    children: [
      // {
      //   path: '/',
      //   name: 'index',
      //   component: () => import('@/views/home/index.vue')
      // },
      {
        path: '/',
        name: 'my',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/views/reader/my.vue')
      },
      {
        path: '/vip',
        name: 'vip',
        meta: {
          title: '会员中心'
        },
        component: () => import('@/views/reader/vip.vue')
      },
      {
        path: '/message',
        name: 'message',
        meta: {
          title: '消息中心'
        },
        component: () => import('@/views/reader/message.vue')
      },
      {
        path: '/subscribe',
        name: 'subscribe',
        meta: {
          title: '我的订阅'
        },
        component: () => import('@/views/reader/subscribe.vue')
      },
      {
        path: '/collect',
        name: 'collect',
        meta: {
          title: '我的收藏'
        },
        component: () => import('@/views/reader/collect.vue')
      },
      {
        path: '/history',
        name: 'history',
        meta: {
          title: '浏览历史'
        },
        component: () => import('@/views/reader/history.vue')
      },
      {
        path: '/shareNews',
        name: 'shareNews',
        meta: {
          title: '分享新闻'
        },
        component: () => import('@/views/reader/shareNews.vue')
      },
      {
        path: '/setting',
        name: 'setting',
        meta: {
          title: '个人设置'
        },
        component: () => import('@/views/reader/setting.vue')
      },
      {
        path: '/myFans',
        name: 'myFans',
        meta: {
          title: '我的粉丝'
        },
        component: () => import('@/views/reader/myFans.vue')
      },
      {
        path: '/follow',
        name: 'follow',
        meta: {
          title: '我的关注'
        },
        component: () => import('@/views/reader/follow.vue')
      },
      {
        path: '/author',
        name: 'author',
        meta: {
          title: '我的漫画'
        },
        component: () => import('@/views/author/index.vue')
      },
      {
        path: '/chapter',
        name: 'chapter',
        meta: {
          title: '章节管理'
        },
        component: () => import('@/views/author/cartoon/chapter.vue')
      },
      {
        path: '/upload',
        name: 'upload',
        meta: {
          title: '新建漫画'
        },
        component: () => import('@/views/author/uploadComics/index.vue')
      },
      {
        path: '/authentication',
        name: 'authentication',
        meta: {
          title: '作者认证'
        },
        component: () => import('@/views/author/authentication/index.vue')
      },
      {
        path: '/notice',
        name: 'notice',
        meta: {
          title: '作者公告'
        },
        component: () => import('@/views/author/notice/index.vue')
      },
      {
        path: '/ballotList',
        name: 'ballotList',
        meta: {
          title: '投票管理'
        },
        component: () => import('@/views/author/ballotList/index.vue')
      },
      {
        path: '/zone',
        name: 'zone',
        meta: {
          title: '空间背景'
        },
        component: () => import('@/views/author/zone/index.vue')
      },
      {
        path: '/other',
        name: 'other',
        meta: {
          title: '他的首页'
        },
        component: () => import('@/views/other/index.vue')
      },
      {
        path: '/work',
        name: 'work',
        meta: {
          title: '他的作品'
        },
        component: () => import('@/views/other/work.vue')
      },
      {
        path: '/otherSub',
        name: 'otherSub',
        meta: {
          title: '他的订阅'
        },
        component: () => import('@/views/other/otherSub.vue')
      },
      {
        path: '/otherFocus',
        name: 'otherFocus',
        meta: {
          title: '他的关注'
        },
        component: () => import('@/views/other/otherFocus.vue')
      },
      {
        path: '/otherFans',
        name: 'otherFans',
        meta: {
          title: '他的粉丝'
        },
        component: () => import('@/views/other/otherFans.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import("@/views/login/index.vue"),
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router